import React from "react";
import { useSearchEngine } from "../hooks";
import {
  clearActiveFilters,
  selectActiveFilters,
  selectIsLoading,
  selectSearchResult,
} from "../store/shared.reducer";
import { useAppDispatch, useAppSelector } from "../store/store.hooks";

export const ActiveSearchFilters: React.VFC = () => {
  /*********************************
   * Variables
   *********************************/
  const pathName =
    typeof window !== "undefined" ? window.location.pathname : ""; // En tillfällig fix. Sökningen kommer inte att fungera utan javascript, eftersom vi behöver sökvägen till sidan.
  const [doSearch] = useSearchEngine(pathName + "/FilterStyrandeDokument");

  const isLoading = useAppSelector(selectIsLoading);
  const activeFilters = useAppSelector(selectActiveFilters);
  const dispatch = useAppDispatch();
  const searchResult = useAppSelector(selectSearchResult);

  /*********************************
   * Functions
   *********************************/
  function clearAllFilters() {
    dispatch(clearActiveFilters());
    doSearch(searchResult.query.resetQuery);
  }

  const removeFilter = (id: string) => {
    // Grab the correct checkbox from DOM and click it to trigger a correct search
    const checkbox = document.getElementById(id) as HTMLInputElement;
    checkbox.click();
  };

  /*********************************
   * Render
   *********************************/
  return (
    <div className="active-filters">
      {activeFilters.length === 0 && <div>Inga aktiva filter</div>}
      {activeFilters.length > 0 && (
        <>
          <div>Aktiva filter:</div>
          <ul>
            {activeFilters.map((filter) => (
              <li key={filter.query}>
                <div className="active-filters__wrapper">
                  <span className="active-filters__title">
                    {filter.displayName}
                  </span>
                  <button
                    disabled={isLoading}
                    onClick={() => removeFilter(filter.id)}
                    className="active-filters__icon"
                  >
                    <span className="sr-only">
                      Ta bort valt filter: {filter.displayName}
                    </span>
                    {closeIcon}
                  </button>
                </div>
              </li>
            ))}
            <li className="clear-filters">
              <button
                disabled={isLoading}
                className="clear-filters__linkbutton clear-filters__clear"
                onClick={() => clearAllFilters()}
                type="button"
              >
                Rensa alla filter
              </button>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

const closeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M10.2426 3.06284C10.6037 2.70181 10.6037 2.11844 10.2426 1.75741C9.88161 1.39638 9.29825 1.39638 8.93721 1.75741L6 4.69462L3.06279 1.75741C2.70175 1.39638 2.11839 1.39638 1.75736 1.75741C1.39633 2.11844 1.39633 2.70181 1.75736 3.06284L4.69457 6.00005L1.75736 8.93726C1.39633 9.2983 1.39633 9.88166 1.75736 10.2427C2.11839 10.6037 2.70175 10.6037 3.06279 10.2427L6 7.30548L8.93721 10.2427C9.29825 10.6037 9.88161 10.6037 10.2426 10.2427C10.6037 9.88166 10.6037 9.2983 10.2426 8.93726L7.30543 6.00005L10.2426 3.06284Z" fill="#005B89"/>
  </svg>
);
